import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Control from './Control';
import Legend from './Legend';
import SchemeAlerts from './Alerts';

import { getCookie } from '../../../helpers/cookie';
import { renderBankIframe } from '../aside/checkout';

class Places extends Component {
  static propTypes = {
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nextStepAfterSchema: PropTypes.func.isRequired,
  };

  static defaultProps = {
    amount: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      width: props.session.width,
      height: props.session.height,
      age: props.session.film.age,
      datetime: props.session.datetime,
      selected: props.selected,
      scale: 1,
      minScale: 1,
      userScale: null,
      boxWidth: 0,
      preselected: [],
      minTicketPrice: null,
      maxTicketPrice: null,
    };
  }

  componentDidMount() {
    this.resizeScheme(true);
    dragscroll.reset();
    // this.selfClosePopup();

    // if (process.env.NODE_ENV === 'dev') {
    const { wait, key } = this.state;
    // const { width, height } = testSession.data;

    this.setState({
      // openTown: false,
      // ask: false,
      // id: session,
      wait: wait + 1,
      // session: testSession.data,
      // places: testSession.data.places,
      // order: testSession.order,
      // noBonus: testSession.data.cinema.no_bonus,
      // order_success: testSession.order_success,
      // errors: [],
      // key: key + 1,
      // selected: testSession.data.selected,
      // exit,
      // is_disabled: testSession.data.disabled,
      // user: testUser.data,
      // loading: false,
    });
    // } else {
    //   this.loadSession(session);
    // }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // this.checkVip();
    this.setState({
      places: nextProps.session.places,
      selected: nextProps.selected,
      preselected: [], // check and clear only needed
    });
  }

  // Снимаем событие с ресайза окна
  componentWillUnmount() {
    $(window).off('load resize orientationchange', this.resizeScheme);
  }

  // Изменение масштаба
  resizeScheme = first => {
    const { userScale, minScale } = this.state;
    const scheme = this.scheme;
    const contentWidth = $(scheme)
      .find('.scheme__body')
      .outerWidth();

    let { scale } = this.state;
    const boxWidth = $(scheme).outerWidth() - 17;

    if (boxWidth < contentWidth) {
      scale = boxWidth / contentWidth;
    }

    if (first) {
      let h =
        $(scheme)
          .find('.scheme__body')
          .outerHeight() * scale;

      $(scheme)
        .parents('.scheme-box')
        .css('maxHeight', `${h}px`);
    }

    this.setState({
      boxWidth: boxWidth,
      scale: scale,
      minScale: scale,
    });
  };

  /*

  // Выбор места
  selectPlace(id) {
    const { disable } = this.props;
    let { preselected, selected } = this.state;

    if (!disable) {
      // if (this.state.preselected.includes(id)) {
      if (preselected.indexOf(id) !== -1) {
        preselected.splice(preselected.indexOf(id), 1);
      } else {
        let c = 8;

        if (selected.indexOf(id) !== -1) {
          c = 9;
        }

        if (selected.length < c) {
          preselected.push(id);
        }
      }

      this.setState({ preselected });
      this.props.onSelectPlace(id);
    }
  }

  selfClosePopup = () => {
    const close = () => {
      this.setState({ isAlert: false });
      this.setState({ isNightAlert: false });
    };
    setTimeout(close, 7000);
  };

  // Проверка вип-мест
  checkVip() {
    const object = this.props.places;
    let prices = [];

    object.forEach(ticket => {
      if (prices.length > 0) {
        prices.includes(ticket.price) ? null : prices.push(ticket.price);
      } else {
        prices.push(ticket.price);
      }
    });

    prices = prices.sort((a, b) => a - b);

    const minValue = obj => Math.min(...obj);
    const maxValue = obj => Math.max(...obj);

    let minPrice = null;
    let maxPrice = null;
    let midPrice = null;

    switch (prices.length) {
      // Если 2 цены
      case 2:
        minPrice = minValue(prices);
        maxPrice = maxValue(prices);
        break;
      // 3
      case 3:
        minPrice = minValue(prices);
        midPrice = prices[1];
        maxPrice = maxValue(prices);
      // Одна цена
      default:
        minPrice = prices[0];
        break;
    }

    this.setState({
      minTicketPrice: minPrice,
      midTicketPrice: midPrice,
      maxTicketPrice: maxPrice,
    });
  }
  */

  // Клик на кнопки резайза
  changeScale(plus) {
    let newScale;

    if (plus) {
      if (this.state.userScale == null) {
        newScale = this.state.scale + 0.25;
      } else {
        newScale = this.state.userScale + 0.25;
      }

      if (newScale > 2) {
        newScale = 2;
      }

      this.setState({
        userScale: newScale,
      });
    } else {
      if (this.state.userScale == null) {
        newScale = this.state.scale - 0.25;
      } else {
        newScale = this.state.userScale - 0.25;
      }

      if (newScale < this.state.minScale) {
        newScale = this.state.minScale;
      }

      this.setState({
        userScale: newScale,
      });
    }
  }

  /*
  // Проверка на наличие аватарки
  checkAvatar = place_id => {
    return null;
    const { avatar } = this.props;

    let img = null;

    Object.keys(avatar).forEach(item => {
      if (item == +place_id) {
        img = this.createAvatar(avatar[item]);
      }
    });

    return img;
  };

  // Создаем аватарку пользователя
  createAvatar = url => {
    return (
      <div
        className="place__avatar"
        style={{ backgroundImage: `url(${url})` }}
      />
    );
  };
  */

  placeSelect(id) {
    const { preselected, selected } = this.state;

    const { onSelect, session } = this.props;

    if (preselected.length + selected.length < 8 && !session.disabled) {
      preselected.push(id);

      this.setState({
        preselected,
      });

      onSelect(id);
    } else if (selected.indexOf(id) > -1) {
      onSelect(id);
    }
  }

  getExits = enters => {
    const exits = enters.map(e => {
      return (
        <div
          className="place-exit"
          key={`${e.x}-${e.y}`}
          style={{
            top: `${e.y}px`,
            left: `${e.x}px`,
          }}
        />
      );
    });

    return exits;
  };

  prepareTotal() {
    const { amount, nextStepAfterSchema, checkout } = this.props;

    if (amount > 0) {
      return (
        <div className="scheme-box__total">
          <button
            className="btn btn--accent"
            type="button"
            onClick={async () => await nextStepAfterSchema()}
          >
            {`Оформить заказ на ${parseInt(amount - checkout.bonusPay)} руб.`}
          </button>
        </div>
      );
    }

    return null;
  }

  render() {
    const { session } = this.props;

    const { datetime, age } = this.state;

    const exits = this.getExits(session.enters);

    // const {
    //   preselected,
    //   maxTicketPrice,
    //   minTicketPrice,
    //   midTicketPrice,
    // } = this.state;
    // const {
    //   order,
    //   selected,
    //   session,
    //   order_success,
    //   is_disabled,
    // } = this.props;
    // const exit = this.props.session.exit;

    // For places price color rendering

    const places = session.places.map(place => {
      // const avatar = this.checkAvatar(place.id);
      // let clickFunc = () => this.selectPlace(place.id);

      // if (is_disabled === true) clickFunc = () => false;

      const classes = ['place'];
      if (place.status) {
        if (this.state.preselected.indexOf(+place.id) !== -1)
          classes.push('place--preselected');
        if (this.state.selected.indexOf(+place.id) !== -1)
          classes.push('place--active');

        return (
          <button
            type="button"
            key={place.id}
            style={{
              left: `${place.x}px`,
              top: `${place.y}px`,
              backgroundColor: `${place.color}`,
            }}
            className={classes.join(' ')}
            data-sold="false"
            onClick={() => this.placeSelect(place.id)}
          >
            <span>{place.place}</span>
            <div className="popover">
              <span className="big">{place.price} ₽</span>
              <span>
                {place.row} ряд, {place.place} место
              </span>
            </div>
          </button>
        );
      }

      let o = 'Занято';

      if (place.isChild) {
        o = 'Детям бесплатно';
      }

      // if (order) {
      //   if (order.session_id === +session) {
      //     if (order.seats.indexOf(+place.id) !== -1) {
      //       o = 'Забронировано';
      //       classes.push('place--reserve');
      //     }
      //   }
      // }

      // if (order_success) {
      //   if (order_success.seats.indexOf(+place.id) !== -1) {
      //     o = 'Ваш заказ';
      //     classes.push('place--buy');
      //   }
      // }

      return (
        <button
          key={place.id}
          type="button"
          style={{
            left: `${place.x}px`,
            top: `${place.y}px`,
            backgroundColor: `${place.color}`,
          }}
          className={classes.join(' ')}
          data-sold="true"
        >
          <span>{place.place}</span>
          {/*avatar*/}
          <div className="popover">
            <span>{o}</span>
          </div>
        </button>
      );
    });

    const rowsY = {};

    this.props.session.places.forEach(item => {
      if (rowsY[item.row] == undefined) {
        rowsY[item.row] = item.y;
      }
    });

    const rows = [];

    Object.keys(rowsY).forEach(key => {
      const html = (
        <span
          key={key}
          className="place-row"
          style={{ top: `${rowsY[key]}px` }}
        >
          {key}
        </span>
      );
      rows.push(html);
    });

    let scale = this.state.scale;

    if (this.state.userScale != null) {
      scale = this.state.userScale;

      if (this.state.userScale < this.state.minScale)
        scale = this.state.minScale;
    }

    const unpaidOrder = getCookie('UNPAID_ORDER');
    const paymentLink = getCookie('PAYMENT_LINK');

    return (
      <div className="scheme-popup__scheme scheme-box">
        <div
          className="scheme-box__inner dragscroll"
          ref={node => (this.scheme = node)}
          style={{ paddingRight: !!('ontouchstart' in window) ? '17px' : '0' }}
        >
          <SchemeAlerts session={session} datetime={datetime} age={age} />

          <div className="scheme">
            {/*<Legend prices={session.prices} disabled={session.disabled} timeout={session.timeout} />*/}
            <div
              style={{ transform: `scale(${scale})` }}
              className="scheme__body"
            >
              <div
                style={{
                  width: `${this.state.width}px`,
                  height: `${this.state.height}px`,
                }}
              >
                <div className="place-rows" style={{ left: 0 }}>
                  {rows}
                </div>
                {exits}
                {places}
                <div className="place-rows" style={{ right: 0 }}>
                  {rows}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scheme-box__controls">
          <Control onZoom={zoom => this.changeScale(zoom)} />
        </div>
        {this.prepareTotal()}

        {unpaidOrder && (
          <React.Fragment>
            <div className="scheme-box__overlay"></div>
            <p className="scheme-box__note scheme-box__note--show">
              У вас есть неоплаченный заказ. Вы&nbsp;можете{' '}
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  window.location.href = paymentLink;
                  // renderBankIframe(paymentLink);
                }}
              >
                оплатить&nbsp;его
              </a>{' '}
              или отменить заказ в&nbsp;
              <a href="/profile">личном&nbsp;кабинете</a>
            </p>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Places;
